/**
 * JoinExamPage — /join/:code
 *
 * Looks up an exam by its 8-char code and redirects to /exam/:id.
 * Shown briefly as a loading screen; on error shows a friendly message.
 */
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getExamByCode } from '@/api/auth'

export default function JoinExamPage() {
  const { code } = useParams()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!code) return
    getExamByCode(code.toUpperCase())
      .then(({ data }) => {
        navigate(`/exam/${data.code}`, { replace: true })
      })
      .catch(() => {
        setError(`"${code.toUpperCase()}" kodi bilan imtihon topilmadi.`)
      })
  }, [code, navigate])

  if (error) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '60vh', gap: 16, padding: 24,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 48 }}>🔍</div>
        <p style={{ fontSize: 16, color: 'var(--color-text, #333)', maxWidth: 320 }}>{error}</p>
        <button
          onClick={() => navigate('/', { replace: true })}
          style={{
            padding: '10px 24px', borderRadius: 12, border: 'none',
            background: 'var(--color-primary, #f97316)', color: '#fff',
            fontSize: 14, fontWeight: 600, cursor: 'pointer',
          }}
        >
          Bosh sahifaga qaytish
        </button>
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', gap: 12,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: '50%', border: '3px solid #f97316',
        borderTopColor: 'transparent', animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ fontSize: 14, color: '#888' }}>
        Imtihon yuklanmoqda — kod: <strong>{code?.toUpperCase()}</strong>
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
